import { createApi} from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./base.api.ts";

interface TicketType {
  ticket_type_id: number;
  ticket_type_name: string;
}

export const ticket_typeApi = createApi({
  reducerPath: "ticket_typeApi",
  baseQuery: customBaseQuery, 
  tagTypes: ['Ticket_type'],
  endpoints: (builder) => ({
    getAllTicketTypes: builder.query<TicketType[], void>({
      query: () => ({
        url: "/gw/ticket-types/all",
        method: "get",
      }),
      transformResponse: (response: TicketType[]) => {
        return response.map((ticket_type: TicketType) => ({
            ticket_type_id: ticket_type.ticket_type_id,
            ticket_type_name: ticket_type.ticket_type_name
        }));
      },
      providesTags: ['Ticket_type'],
    }),
  }),
});

export const { 
  useGetAllTicketTypesQuery 
} = ticket_typeApi;
